import React from "react";
import { Instagram, Mail, MessageCircle } from "lucide-react";

export const Footer = ({ t }) => {
  return (
    <footer
      data-testid="footer"
      className="bg-stone-950 text-[#cececc] py-20 md:py-24"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <p className="font-serif tracking-[0.4em] text-2xl md:text-3xl">
              {t.footer.brand}
            </p>
            <p className="mt-4 text-stone-400 text-sm font-light">
              {t.footer.tag}
            </p>
            <p className="mt-2 text-stone-500 text-[11px] uppercase tracking-[0.3em]">
              {t.footer.founded}
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.35em] text-stone-500 mb-6">
              — {t.footer.links}
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="https://www.instagram.com/amme.estate"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="inline-flex items-center gap-3 text-stone-200 hover:text-[#a7a7a5] transition-colors text-sm font-light"
              >
                <Instagram size={14} strokeWidth={1.5} />
                <span>@amme.estate</span>
              </a>
              <a
                href="https://wa.me/13102002030"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-3 text-stone-200 hover:text-[#a7a7a5] transition-colors text-sm font-light"
              >
                <MessageCircle size={14} strokeWidth={1.5} />
                <span>+1 310 200 2030</span>
              </a>
              <a
                href="mailto:info@ammeestate.com"
                data-testid="footer-email"
                className="inline-flex items-center gap-3 text-stone-200 hover:text-[#a7a7a5] transition-colors text-sm font-light"
              >
                <Mail size={14} strokeWidth={1.5} />
                <span>info@ammeestate.com</span>
              </a>
            </div>
          </div>

          <div className="md:col-span-3 md:text-right">
            <p className="text-[11px] uppercase tracking-[0.35em] text-stone-500 mb-6">
              — Location
            </p>
            <p className="text-stone-300 text-sm font-light leading-[1.8]">
              Payangan, North of Ubud
              <br />
              Bali, Indonesia
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-stone-800 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-[11px] uppercase tracking-[0.3em] text-stone-500">
            {t.footer.rights}
          </p>
          <p className="text-[11px] uppercase tracking-[0.3em] text-stone-500 font-serif italic">
            Ubud · Bali · 2026
          </p>
        </div>
      </div>
    </footer>
  );
};
